// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03b3f005","239":"4d63e918","732":"84e2d8df","762":"dd8bb7c6","857":"53491617"}[chunkId] + ".chunk.js";
};